import { useSnackbar } from 'notistack';
import { Trans, useTranslation } from 'react-i18next';
import useAuth from '../hooks/useAuth';
import { Alert, Link } from '@mui/material';

export default function EmailSuppressionStatus(others) {
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();
  const { user, isEmailSuppressed, sendVerificationToUnsuppressEmail } =
    useAuth();

  const handleVerify = async () => {
    const result = await sendVerificationToUnsuppressEmail({
      email: user.email,
    });
    if (result.status) {
      enqueueSnackbar(t('email-suppression.reverify-email-sent'), {
        variant: 'success',
      });
    }
  };

  return (
    <>
      {isEmailSuppressed && (
        <Alert severity="error" {...others}>
          <Trans
            i18nKey="email-suppression.issue-sending-email"
            components={{ anchor: <Link href="#" onClick={handleVerify} /> }}
          />
        </Alert>
      )}
    </>
  );
}
